import {useCallback } from "react";
import {useDispatch } from "react-redux";
import { setLocation } from "../features/detectSlice";
// import { useDetect } from "../contexts/DetectContext";

export default function useLocation() {
    const dispatch = useDispatch();
    // const {location} = useSelector(state => state.detection);
   
  
  const fetchLocation = useCallback(
    function () {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                // Success callback
                const { latitude, longitude } = position.coords;
                // console.log(position);
                // setLocation({ latitude, longitude });
                dispatch(setLocation(latitude,longitude));
                // LocationRef.current = { latitude, longitude };
            },
            (err) => {
                // Error callback
                dispatch(setLocation(-1,-1));;
            }
        );
        // dispatch(setLocation(Math.random(),Math.random()));
    },
    [dispatch]
);

  return {fetchLocation};
}